import Api from "../../config/api";
import {
  CREATE_DEMO_REQUEST,
  SEARCH_DEMO_REQUEST,
  SEARCH_DEMO_REQUEST_BY_ID,
  UPDATE_DEMO_REQUEST,
} from "../../utils/constants";
import { showToast } from "../toast/ShowToast";

export const getDemoRequest = async (params?: any) => {
  try {
    const res = await Api(false).get(SEARCH_DEMO_REQUEST, { params });
    return res;
  } catch (error: any) {
    if (error?.response?.status >= 400 && error?.response?.status <= 499) {
      showToast(`${error.response.statusText}`, "error");
    } else {
      showToast(`${error?.response?.data?.message}`, "error");
    }
  }
};

export const getDemoRequestById = async (id?: string) => {
  try {
    const res = await Api(false).get(`${SEARCH_DEMO_REQUEST_BY_ID}/${id}`);
    return res;
  } catch (error: any) {
    if (error?.response?.status >= 400 && error?.response?.status <= 499) {
      showToast(`${error.response.statusText}`, "error");
    } else {
      showToast(`${error?.response?.data?.message}`, "error");
    }
  }
};

export const createDemoRequest = async (body: any, hideLoader: () => void) => {
  try {
    const res = await Api(false).post(CREATE_DEMO_REQUEST, body);
    return res;
  } catch (error: any) {
    if (error.response.status >= 400 && error.response.status <= 499) {
      showToast(`${error.response.statusText}`, "error");
      hideLoader();
    } else {
      showToast(`${error.response.data.message}`, "error");
      hideLoader();
    }
  }
};

export const updateDemoRequest = async (
  body: any,
  id: string,
  hideLoader: () => void
) => {
  try {
    const res = await Api(false).put(`${UPDATE_DEMO_REQUEST}/${id}`, body);
    return res;
  } catch (error: any) {
    if (error.response.status >= 400 && error.response.status <= 499) {
      showToast(`${error.response.statusText}`, "error");
      hideLoader();
    } else {
      showToast(`${error.response.data.message}`, "error");
      hideLoader();
    }
  }
};
